import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { AdminUpdateInternalTrainingBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminUpdateInternalTraining = createAsyncThunk<void, AdminUpdateInternalTrainingBody, { extra: Partial<Dependencies> }>(
  "internalTrainings/updateInternalTraining",
  async (body: AdminUpdateInternalTrainingBody, { extra: { adminRepository } }) => {
    return adminRepository!.updateInternalTraining(body);
  },
);

export const adminResetUpdateInternalTraining = createAction("internalTrainings/resetUpdateInternalTraining");
